import { Sidebar } from '@/modules'
import SidebarTanks from '@/modules/sidebar-aqua/Sidebar'
import MenuIcon from '@mui/icons-material/Menu'
import { Box, IconButton } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { Outlet, useSearchParams } from 'react-router-dom'
import DialogQuestion from '@/components/Dialog/Dialog'

const Layout = () => {
  const [isShowSideBar, setIsShowSidebar] = useState(false)
  const [imgSrc, setImgSrc] = useState('')
  const [searchParams, setSearchParams] = useSearchParams()
  const showImage = searchParams.get('showImage')
  const isRobertAqua = import.meta.env.VITE_APP_NAME === 'RobertAqua'

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      if (target?.classList?.contains('balloon-img')) {
        setImgSrc((target as HTMLImageElement)?.src || '')
        setSearchParams((prev) => {
          prev.set('showImage', target?.className)
          return prev
        })
      }
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [setSearchParams])

  const handleCloseImageDialog = () => {
    setSearchParams((prev) => {
      prev.delete('showImage')
      return prev
    })
  }
  return (
    <>
      <IconButton
        className='sidebar_button'
        onClick={() => setIsShowSidebar(true)}
      >
        <MenuIcon />
      </IconButton>
      <Box
        className={isRobertAqua ? 'layout layoutAqua' : 'layout'}
        display='flex'
        flexDirection='row'
      >
        {isRobertAqua ? (
          <SidebarTanks
            isShowSideBar={isShowSideBar}
            setIsShowSidebar={setIsShowSidebar}
          />
        ) : (
          <Sidebar
            isShowSideBar={isShowSideBar}
            setIsShowSidebar={setIsShowSidebar}
          />
        )}
        <Outlet />
      </Box>
      <DialogQuestion
        open={!!showImage}
        handleClose={handleCloseImageDialog}
        handleAgree={handleCloseImageDialog}
        disableGutters={true}
        message={
          <div
          // style={{
          //   maxHeight: '50vh',
          // }}
          >
            <img
              style={{
                width: '100%',
                maxHeight: '85vh',
                objectFit: 'contain',
              }}
              src={imgSrc}
            />
          </div>
        }
        agreeText='Закрыть'
        showClose={false}
        fullWidth={true}
        maxWidth={false}
      />
    </>
  )
}

export default Layout
